define('environments/development',{
  apiHost: 'https://landings-backend.dev.mdirector.com',
  authHost: 'https://signup-backend.dev.mdirector.com/auth/accessLandings',
  loginUrl: 'https://signup-backend.dev.mdirector.com/auth/landings',
  defaultDomain: 'https://landings.dev.mdirector.com',
  signupUrl: 'https://signup.dev.mdirector.com',
  signupBackendUrl: 'https://signup-backend.dev.mdirector.com',
  logoutUrl: 'https://signup-backend.dev.mdirector.com/auth/logoutLandings',
  i18nCookieDomain: '.mdirector.com',
  cdnDomain: 'https://landings-backend.dev.mdirector.com',
  antispamWord: 'real_email-real_email',
  assetsHost: 'https://static.dev.mdirector.com/assets/',
  validationServerHostSuffix: '/amp-form-validation',
  gtmUrl: 'https://www.googletagmanager.com/amp.json',
  themeAssetsUrl: 'https://static.dev.mdirector.com/assets/themes/',
  paymentsUrl: 'https://payments.dev.mdirector.com',
  maxImageSizeToUpload: 5242880, // 5MB

  // GruID (strings)
  groupsAllowedToAMP: ['20941', '1884'],
  // Prevent refresh browser's warning when the editor content has been changed without saving.
  disablePageRefreshWarning: true,
  avoidConfirmMessages: true,
});

